import { CardActionPassword } from "@/components/Cards/View/Details/Actions/Password"

export const CardDetailsActions = () => {
  return (
    <div className="main-content_list-btn [&>button]:flex-shrink-0">
      {/*<CardActionFreeze />*/}
      <CardActionPassword />
    </div>
  )
}
